import { render, staticRenderFns } from "./StatisticsReportList.vue?vue&type=template&id=ec9fe3c0&scoped=true"
import script from "./StatisticsReportList.vue?vue&type=script&lang=js"
export * from "./StatisticsReportList.vue?vue&type=script&lang=js"
import style0 from "./StatisticsReportList.vue?vue&type=style&index=0&id=ec9fe3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9fe3c0",
  null
  
)

export default component.exports